import axios from 'axios';
import { logoutUser } from './authService';  // Assuming this clears localStorage and other session-related data
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';  // You'll need to import navigate into your app context

export const API_URL = 'https://api.globalvisionsinc.com.ph';  // Change this to your actual API URL

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

// Global request interceptor to attach the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global response interceptor to catch invalid token errors
api.interceptors.response.use(
  (response) => response,  // return the successful response
  (error) => {
    if (error.response) {
      const { errorMessage, errorCode } = error.response.data;

      // Check if the error is due to invalid/expired token
      if (errorCode === 'AUTH_INVALID_TOKEN') {
        // Handle the token expiration here
        logoutUser();  // Clear user session

        // Redirect to login page and notify user
        const navigate = useNavigate();
        navigate('/login'); // Use `navigate` directly in your component
        toast.error('Your session has expired. Please log in again.');
      }
    }
    return Promise.reject(error); // Reject the error so it can be handled further if necessary
  }
);

export default api;
